/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_theme_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const zh_hans1_theme_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浅色`)
};

const zh_hant1_theme_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`淺色`)
};

const fr_theme_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clair`)
};

const de_theme_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hell`)
};

const ja_theme_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライト`)
};

const ko_theme_light = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이트`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const theme_light = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.theme_light(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("theme_light", locale)
	if (locale === "en") return en_theme_light(inputs)
	if (locale === "zh-Hans") return zh_hans1_theme_light(inputs)
	if (locale === "zh-Hant") return zh_hant1_theme_light(inputs)
	if (locale === "fr") return fr_theme_light(inputs)
	if (locale === "de") return de_theme_light(inputs)
	if (locale === "ja") return ja_theme_light(inputs)
	return ko_theme_light(inputs)
};